import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.sass']
})
export class SupportComponent implements OnInit {
  public content:object;
  public tabActive='Soporte';
  public currentList;
  public postpago=false;
  public prepago=false;
  public telefoniaFijo=false;
  public totalAccountList;
  public token:string=sessionStorage.getItem("token");
  public selectBan;

  constructor(public AngularFireAnalytics:AngularFireAnalytics, public global:GlobalService) {
    this.AngularFireAnalytics.setCurrentScreen("Soporte");
    this.AngularFireAnalytics.logEvent("Soporte-Screenview");
   }
  
  ngOnInit() {
    this.content={
      content:[
        {
          title:"¿Que es Mi Claro Empresas?",
          description:"Mi Claro es portal responsivo diseñado para ser compatible con un desktop, tableta o dispositivo móvil donde el cliente de negocio podrá realizar transacciones administrativas de su cuentas, tales como, pagos totales o parciales de factura, descargar su factura, ver histórico de pagos y edición de preferencias de notificaciones de su factura electronica entre otros.",
          expand:true
        },
        {
          title:"¿Cómo puedo acceder a Mi Claro Empresas?",
          description:"Puede acceder a Mi Claro Empresas a través de la página Web: https://empresas.claroinfo.com/login o descargar Mi Claro PR a través del App Store de su unidad móvil.",
          expand:false
        },
        {
          title:"¿Qué información necesito para registrarme?",
          description:"Mi Claro es portal responsivo diseñado para ser compatible con un desktop, tableta o dispositivo móvil donde el cliente de negocio podrá realizar transacciones administrativas de su cuentas, tales como, pagos totales o parciales de factura, descargar su factura, ver histórico de pagos y edición de preferencias de notificaciones de su factura electronica entre otros.",
          expand:false
        }
      ]
    };
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
}
